module.exports = __webpack_public_path__ + "img/signal-animation-s.10275421.png";